import { useAuthenticationService } from '@/services/authentication/authentication-service';
import { useOptionalLocationService } from '@/services/location/LocationService';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import { createErrorToast } from '@/services/notification/ToastService';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import strings from './tenantManagement.translations';

export const useExitDelegation = () => {
  const navigate = useNavigate();
  const setSelectedLocation = useOptionalLocationService(state => state.setSelectedLocation);
  const { previousAdminLocation, setActingLocation, setPreviousAdminLocation } = useAdminLocationStore(state => ({
    previousAdminLocation: state.previousAdminLocation,
    setActingLocation: state.setActingLocation,
    setPreviousAdminLocation: state.setPreviousAdminLocation
  }));
  const endDelegation = useAuthenticationService(state => state.endDelegation);

  return useCallback(async () => {
    try {
      navigate('/', { replace: true });
      await endDelegation();
      setActingLocation(undefined);
      setSelectedLocation?.(previousAdminLocation);
      setPreviousAdminLocation(undefined);
    } catch (error) {
      console.error(error);
      createErrorToast(strings.delegationBar.exitError);
    }
  }, [endDelegation, navigate, previousAdminLocation, setActingLocation, setPreviousAdminLocation, setSelectedLocation]);
};
